import React from 'react';

import { UsefulLinks } from 'features/order-tracker/shared-components';

import styles from './styles.module.scss';

export const HelpBox: React.FC<components.HelpBox> = ({ title, links }) => (
  <div className={styles.helpBoxContainer}>
    <h3 className={styles.helpBoxTitle}>{title}</h3>
    <UsefulLinks links={links} />
  </div>
);
